import {
  getPaginatedOrders,
  getOrderStatus,
  getOrderDetail,
  getOrderStatusChanges,
  getDriverOrders,
  getOrderTypes,
  getDriverOrdersDetail,
} from './Queries'
import {
  createOrder,
  setOrderStatus,
  setOrderStatusAndUpdateOrder,
  setDeliveryNoteCustomer,
  setDeliveryNoteSupplier,
  editOrder,
  appendPilesToExistingOrder,
  deletePilesFromExistingOrder,
  rollbackOrderStatusChange,
  changeToNextStatus,
  saveRoute,
  editOrderAndMilages,
  editOrderIsPlausible,
} from './Mutations'
import { DriverOrderNodeFragment } from './Fragments'

export const Order = {
  appendPilesToExistingOrder,
  createOrder,
  DriverOrderNodeFragment,
  deletePilesFromExistingOrder,
  editOrder,
  getDriverOrders,
  getDriverOrdersDetail,
  getOrderDetail,
  getOrderStatusChanges,
  getOrderStatus,
  setOrderStatusAndUpdateOrder,
  getOrderTypes,
  getPaginatedOrders,
  setDeliveryNoteCustomer,
  setDeliveryNoteSupplier,
  setOrderStatus,
  rollbackOrderStatusChange,
  saveRoute,
  changeToNextStatus,
  editOrderAndMilages,
  editOrderIsPlausible,
}
